module.exports = __webpack_public_path__ + "img/rr.f9cafa27.svg";